import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Popconfirm,
  Tooltip,
  Table,
  Input,
  Modal,
  Divider,
  Form,
  InputNumber,
  DatePicker,
  notification,
  Typography,
  Card,
  Checkbox,
  Spin,
} from "antd";
import * as XLSX from "xlsx";
import {
  CloseCircleFilled,
  DeleteFilled,
  ExportOutlined,
  PlusCircleOutlined,
  SyncOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { BpiService } from "../Services/BpiService";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import TableDOc from "./TableDoc";
import { AdherentsService } from "../Services/AdherentsService";
import { ParticipantsIpmService } from "../Services/ParticipantsIpmService";
import { TypesBenefsService } from "../Services/TypesBenefsServices";
import { SpecialitesService } from "../Services/SpecialitesService";
import { ListFournisService } from "../Services/ListFournisService";
import { PrestationsService } from "../Services/PrestationsService";
import moment from "moment";

const { confirm } = Modal;
const { Option } = Select;
const { Text } = Typography;

const Lettregarant = () => {
  const bpiService = new BpiService();
  const exerciceDocService = new ExerciceDocService();
  const adherentsService = new AdherentsService();
  const participantsIpmService = new ParticipantsIpmService();
  const prestationsService = new PrestationsService();
  const specialistesService = new SpecialitesService();
  const typesBenefsService = new TypesBenefsService();
  const fournisseurService = new ListFournisService();
  const userProfil = localStorage.getItem("profil")

  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const getSelectedYear = () => new Date().getFullYear().toString();
  const [isParticipantInactive, setIsParticipantInactive] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [addedRows, setAddedRows] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("KO");

  const [filteredData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [participantsData, setParticipantsData] = useState(null);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [qteTotal, setqteTotal] = useState(0);
  const [prestationsData, setPrestationsData] = useState(null);
  const [fournisseursData, setFournisseurData] = useState(null);
  const [numdoc, setNumdoc] = useState(null);
  const [isPrescripteurSelect, setIsPrescripteurSelect] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingValid, setLoadingValid] = useState(false); // Ajoute cet état en haut du composant BonsPharma
  const [benefsData, setBenefsData] = useState(null);
  const [partsData, setPartsData] = useState(null);
  const [actesData, setActesData] = useState([]);
  const [isSaisirMedicamentClicked, setIsSaisirMedicamentClicked] =
    useState(false);
  const [specialitesData, setSpecialitesData] = useState(null);
  const [prescripteursData, setPrescripteursData] = useState([]);
  const [prestatairesData, setPrestatairesData] = useState([]);
  const [isMatriculeSelected, setIsMatriculeSelected] = useState(false);
  const [allBeneficiaires, setAllBeneficiaires] = useState([]);
  const [isBeneficiaireSelected, setIsBeneficiaireSelected] = useState(false);
  const [beneficiaires, setBeneficiaires] = useState([]);
  const [isDateSelected, setIsDateSelected] = useState(false);
  const [addedMedicaments, setAddedMedicaments] = useState([]);
  const [isPrescripteurSelectEnabled, setIsPrescripteurSelectEnabled] =
    useState(false);
  const [isPrescripteurManuallySelected, setIsPrescripteurManuallySelected] =
    useState(false);
  const [adherents, setAdherents] = useState([]);
  const [years, setYears] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isBonManuel, setIsBonManuel] = useState(false); // État pour la case à cocher "Bon Manuel"
  const userId = localStorage.getItem('login');
  const userRoleName = localStorage.getItem("role_name");
  // Fonction pour gérer le changement de la case à cocher
  const handleBonManuelChange = (e) => {
    setIsBonManuel(e.target.checked);
  };
  const selectedTypeDoc = "LGI"

  const [form] = Form.useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getAllExercicesDoc();
        setYears(yearsData);
        // await fetchDataByOption(selectedOption);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [selectedYear, selectedOption]);

  useEffect(() => {
    fetchDataByOption(selectedOption);
  }, [selectedYear, selectedTypeDoc, selectedOption]);

  const handleDeleteline = async (numdoc) => {
    try {
      confirm({
        title: "Êtes-vous sûr de vouloir supprimer cette prestation ?",
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await bpiService.deleteDoc(numdoc);
            const updatedData = filteredData.filter(
              (item) => item.numdoc !== numdoc
            );
            setFilteredData(updatedData);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel() {
          // Annulation
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };

  const fetchDataByOption = async (option) => {
    setLoading(true);
    try {
      const data = await bpiService.getAllBci(selectedTypeDoc, option, selectedYear);

      const filteredData = (userRoleName === "Point_Focal" || userRoleName === "Point Focal")
        ? data.filter(item => item.user_id === userId)
        : data;

      setTableData(filteredData);
      setLoading(false);
      // setShowAdditionalColumns(shouldShowAdditionalColumns);
    } catch (error) {
      setLoading(false);
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData, refreshTable]);

  const handleSelectChange = (value) => {
    setSelectedOption(value);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  const handleRefresh = async () => {
    setRefreshTable(true); // Commencez à afficher l'indicateur de chargement
    try {
      await fetchDataByOption(selectedOption);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setRefreshTable(false); // Masquez l'indicateur de chargement une fois les données récupérées
    }
  };

  //Filtre recherche
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };

  const handleSocieteChange = async (value) => {
    try {
      let participantsData;
      if (!isEdit) {
        participantsData = await participantsIpmService.getOneListtParticipant(
          value
        );
      } else {
        participantsData = await participantsIpmService.getOneEtParticipant(
          value
        );
      }
      setParticipantsData(participantsData);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du participant :",
        error
      );
    }
  };

  /*   const fetchAdherents = async () => {
      try {
        const adherentsData = await adherentsService.getAllAdherents();
        setAdherents(adherentsData);
      } catch (error) {
        console.error("Erreur lors de la récupération des adhérents :", error);
      }
    }; */

  const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsService.getAllAdherents();

      // Filtrer les adhérents pour exclure ceux qui ont suspension_adht à true
      const filteredAdherents = adherentsData.filter(
        (adherent) => !adherent.suspension_adht
      );
      setAdherents(filteredAdherents);

    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const handlePrescripteur = (value) => {
    // Définir l'état isDateSelected sur true lorsque la date est sélectionnée
    setIsPrescripteurSelect(!!value);
  };

  /*   const handleMatPartChange = async (value) => {
      try {
        const participantData = await participantsIpmService.getOneParticipant(value);
        if (participantData.suspension_part === "S") {
          setSelectedParticipant(participantData);
          setIsParticipantInactive(true);
          return;
        }
    
        const benefData = await participantsIpmService.getBenefParticipant(value);
        setAllBeneficiaires(benefData);
        setBeneficiaires(benefData);
        setPartsData(participantData);
        setIsMatriculeSelected(true);
        setIsBeneficiaireSelected(false);
        form.setFieldsValue({
          codetype: undefined,
          matribenef: undefined,
        });
      } catch (error) {
        notification.error({
          message: "Erreur",
          description: "Erreur lors de la récupération des données du participant",
        });
      }
    };
     */

  const handleMatPartChange = async (value) => {
    try {
      const participantData = await participantsIpmService.getOneParticipant(value);

      if (participantData.suspension_part === "S") {
        setSelectedParticipant(participantData);
        setIsParticipantInactive(true);
        return;
      }

      if (participantData.suspension_adht) {
        Modal.confirm({
          title: "Société suspendue!",
          content: "Voulez-vous confirmer cette opération malgré la suspension?",
          okText: "Valider",
          cancelText: "Annuler",
          onOk: async () => {
            // Continue l'action si "Valider" est cliqué
            proceedWithMatPartChange(value, participantData);
          },
          onCancel: () => {
            // Réinitialise la sélection si "Annuler" est cliqué
            form.resetFields(["matripart"]);
          },
        });
        return;
      }

      proceedWithMatPartChange(value, participantData);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des données du participant",
      });
    }
  };

  // Fonction pour continuer après validation
  const proceedWithMatPartChange = async (value, participantData) => {
    try {
      const benefData = await participantsIpmService.getBenefParticipant(value);
      setAllBeneficiaires(benefData);
      setBeneficiaires(benefData);
      setPartsData(participantData);
      setIsMatriculeSelected(true);
      setIsBeneficiaireSelected(false);
      form.setFieldsValue({
        codetype: undefined,
        matribenef: undefined,
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des bénéficiaires",
      });
    }
  };

  const handleTypeBenefChange = async (value) => {
    try {
      // Récupérer les bénéficiaires filtrés en fonction du codetype sélectionné
      const filteredBeneficiaires = allBeneficiaires.filter(
        (beneficiaire) => beneficiaire.codebenef === value
      );
      if (filteredBeneficiaires.length === 0) {
        // Si aucun bénéficiaire n'est trouvé, désactiver le champ du bénéficiaire
        form.setFieldsValue({
          matribenef: undefined,
        });
        setIsBeneficiaireSelected(false);
      } else {
        // S'il y a des bénéficiaires, les mettre à jour dans l'état et activer le champ du bénéficiaire
        setBeneficiaires(filteredBeneficiaires);
        setIsBeneficiaireSelected(true);
        // Sélectionner le premier bénéficiaire de la liste
        form.setFieldsValue({
          matribenef: filteredBeneficiaires[0].matribenef,
        });
      }
    } catch (error) {
      console.error("Erreur lors du filtrage des bénéficiaires :", error);
      // Gérer l'erreur si nécessaire
    }
  };

  const fetchTypeBenef = async () => {
    try {
      const typeBenefData = await typesBenefsService.getAllTypesBenefs();
      setBenefsData(typeBenefData);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  const fetchSpecialite = async () => {

    try {
      const specialites = await specialistesService.getAllSpecialites();
      // Exclure les codespe:04 et codespe:06
      const filteredSpecialites = specialites.filter(
        (specialite) => specialite.codespe !== "04" && specialite.codespe !== "06"
      );
      setSpecialitesData(filteredSpecialites);
    } catch (error) {
      console.error("Erreur lors de la récupération des spécialités :", error);
    }
  };

  const fetchPrestation = async () => {
    try {
      const prestations = await prestationsService.getAllPrestation();
      setPrestationsData(prestations);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  useEffect(() => {
    const fetchfouisseurs = async () => {
      try {
        const fournisseurs = await fournisseurService.getAllListFournis();
        setFournisseurData(fournisseurs);
      } catch (error) {
        console.error("Erreur lors de la récupération des adhérents :", error);
      }
    };
    fetchfouisseurs();
  }, []);

  const handlePrescripteurSpecialiteChange = (value) => {
    try {
      const prescripteurs = fournisseursData.filter(
        (fournisseur) => fournisseur.codespe === value
      );
      setPrescripteursData(prescripteurs);
      setIsPrescripteurSelectEnabled(true);
      setIsPrescripteurManuallySelected(true); // L'utilisateur a choisi manuellement une spécialité de prescripteur
      form.setFieldsValue({ prescripteurSpe: value });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des prescripteurs :",
        error
      );
    }
  };

  const handlePrestataireSpecialiteChange = async (value) => {
    try {
      const prestataires = fournisseursData.filter(
        (fournisseur) => fournisseur.codespe === value
      );
      setPrestatairesData(prestataires);
      setIsPrescripteurSelectEnabled(true);

      if (!isPrescripteurManuallySelected) {
        form.setFieldsValue({ codespe: value });

        const prescripteurs = fournisseursData.filter(
          (fournisseur) => fournisseur.codespe === value
        );
        setPrescripteursData(prescripteurs);
        form.setFieldsValue({ prescripteurSpe: value });

        if (value) {
          const actesResponse = await specialistesService.AddActe(value);
          setActesData(actesResponse);
        }
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des prestataires :", error);
    }
  };

  const handleExportClick = () => {
    const columns = Object.keys(filteredData[0] || {});
    setSelectedColumns(columns);
    setIsExportModalVisible(true);
  };

  const handleExportModalOk = () => {
    const dataToExport = filteredData.map((row) => {
      const rowData = {};
      selectedColumns.forEach((column) => {
        rowData[column] = row[column];
      });
      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ExportData");

    XLSX.writeFile(workbook, "export.xlsx");
    setIsExportModalVisible(false);
  };

  const handleExportModalCancel = () => {
    setIsExportModalVisible(false);
  };

  const handleColumnChange = (checkedValues) => {
    setSelectedColumns(checkedValues);
  };

  const handlePrestataireChange = (value) => {
    form.setFieldsValue({ codefourn: value });
    if (!isPrescripteurManuallySelected && !form.getFieldValue("codepresc")) {
      form.setFieldsValue({ codepresc: value });
    }
  };

  const handlePrescripteurChange = (value) => {
    form.setFieldsValue({ codepresc: value });
    setIsPrescripteurManuallySelected(true);
  };

  const handleActesChange = (value) => {
    // Définir l'état isDateSelected sur true lorsque la date est sélectionnée
    setIsSaisirMedicamentClicked(!!value);
  };

  const handleDateChange = (value) => {
    // Définir l'état isDateSelected sur true lorsque la date est sélectionnée
    setIsDateSelected(!!value);
  };

  const handleAddRow = () => {
    const values = form.getFieldsValue();
    const { libacte, qte, prix_unitaire } = values;
    const montant = qte * prix_unitaire;

    // Vérifier si le médicament a déjà été ajouté
    if (addedMedicaments.includes(libacte)) {
      // Affichez une notification indiquant que le médicament a déjà été ajouté
      notification.warning({
        message: "Duplication ",
        description: "Ce médicament a déjà été ajouté à la table.",
      });
      return;
    }

    setqteTotal((prevqteTotal) => prevqteTotal + qte);

    const newRow = {
      numero: addedRows.length + 1,
      libacte,
      qte,
      prix_unitaire,
      montant,
    };

    setAddedRows((prevAddedRows) => [...prevAddedRows, newRow]);
    setAddedMedicaments((prevAddedMedicaments) => [
      ...prevAddedMedicaments,
      libacte,
    ]);
    setIsTableVisible(true);

    // Réinitialisez les champs du formulaire si nécessaire
    form.resetFields(["libacte", "qte", "prix_unitaire"]);
  };

  const handleDelete = (record) => {
    // Par exemple, utilisez setAddedRows pour mettre à jour l'état
    const updatedRows = addedRows.filter((row) => row.numero !== record.numero);
    setAddedRows(updatedRows);

    // Mettez à jour le nombre d'articles en soustrayant la quantité supprimée
    setqteTotal((prevqteTotal) => prevqteTotal - record.qte);
  };

  const handleClearTable = () => {
    // Réinitialisez le nombre d'articles
    setqteTotal(0);

    // Réinitialisez la liste des lignes
    setAddedRows([]);

    // Réinitialisez la liste des médicaments ajoutés
    setAddedMedicaments([]);
  };

  const handleOpenModal = async (isManual = false) => {
    setIsBonManuel(isManual);
    setLoadingModal(true);
    setIsModalVisible(true);

    try {
      await Promise.all([
        fetchPrestation(),
        fetchSpecialite(),
        fetchTypeBenef(),
        fetchAdherents(),
      ]);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setLoadingModal(false); // Masquez l'indicateur de chargement une fois les données récupérées
    }
  };


  const handleCloseModal = () => {
    form.resetFields(); // Réinitialiser les champs du formulaire
    setIsModalVisible(false); // Ferme le modal
    setAddedRows([]);
    setIsEdit(false); // Réinitialiser l'état d'édition
    setParticipantsData(false);
    setIsMatriculeSelected(false);
    setIsTableVisible(false);
    setIsBeneficiaireSelected(false);
    setIsPrescripteurManuallySelected(false);
    setIsPrescripteurSelectEnabled(false);
    setIsPrescripteurSelect(false);
    setIsBonManuel(false)
  };
  const handleCloseModalValid = () => {
    form.resetFields(); // Réinitialiser les champs du formulaire

    setAddedRows([]);
    setIsEdit(false); // Réinitialiser l'état d'édition
    setParticipantsData(false);
    setIsMatriculeSelected(false);
    setIsTableVisible(false);
    setIsBeneficiaireSelected(false);
    setIsPrescripteurManuallySelected(false);
    setIsPrescripteurSelectEnabled(false);
    setIsPrescripteurSelect(false);

  };

  const handleOk = () => {

    if (loadingValid) return; // Empêche le double clic rapide
    setLoadingValid(true);

    form
      .validateFields()
      .then(async (values) => {
        const participantDetails = partsData || { categprof: 'N/A' };
        console.log("Form values:", values);
        const actes = addedRows.map((row) => ({
          Prestation: {
            codeacte: row.libacte, // Ensure libacte contains the codeacte value
            libacte: row.libacte,
            qte: row.qte,
            coef: 1,
            codespe: values.codespe,
            codeprest: values.codefourn,
          },
          ajustmt: 0,
          codeprest: values.codefourn,
          fexclus: 0,
          freel: 0,
          intitule: "",
          numdoc: "",
          numligne: null,
          qpassur: 0,
          qpmut: 0,
          qte: row.qte,
          tarif: row.prix_unitaire,
          ticket: 0,
        }));

        const docData = {
          actes,
          categprof: participantDetails.categprof,
          natprest: values.natprest,
          codefourn: values.codefourn,
          codesoc: values.codesoc,
          codepresc: values.codepresc,
          datepresc: values.datepresc
            ? values.datepresc.format("YYYY-MM-DD")
            : "",
          codeprest: values.prestataireSpe,
          matribenef: values.matribenef,
          matripart: values.matripart,
          montant_remise: values.montant_remise,
          montdoc: values.montdoc,
          nbarticle: values.nbarticle,
          numdoc: isBonManuel ? values.numdoc : null,
          datedoc: isBonManuel
            ? values.datedoc?.format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),

          remb_integral: values.remb_integral,
          typebenef: values.typebenef,
          typedoc: "LGI",
          user_id: userId,
        };

        try {
          const response = await bpiService.AddDoc(docData);

          if (response.Added === false) {
            notification.error({
              message: "Erreur",
              description: "Numéro de bon déjà ajouté.",
            });
          } else {
            handleCloseModalValid();
            fetchDataByOption(selectedOption);
            notification.success({
              message: "Succès",
              description: "Le document a été ajouté avec succès.",
            });
          }
        } catch (error) {
          console.error("Erreur lors de l'ajout du document :", error);
          notification.error({
            message: "Erreur",
            description: "Erreur lors de l'ajout du document: " + error.message,
          });
        }
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      })
      .finally(() => {
        setLoadingValid(false); // Réinitialiser l'état de chargement après la validation
      });
  };


  const handleEdit = async (record) => {
    setIsEdit(true);
    setLoadingModal(true);
    setIsModalVisible(true);
    try {
      const [
        details,
        adherentsData,
        participantsData,
        benefData,
        benefsData,
        specialites,
        prescripteursData,
        prestationsData,
        fournisseursData,
      ] = await Promise.all([
        bpiService.GetDetailBpi(record.numdoc),
        adherentsService.getAllAdherents(),
        participantsIpmService.getOneEtParticipant(record.codesoc),
        participantsIpmService.getBenefParticipant(record.matripart),
        typesBenefsService.getAllTypesBenefs(),
        specialistesService.getAllSpecialites(),
        fournisseurService.getAllListFournis(),
        prestationsService.getAllPrestation(),
        fournisseurService.getAllListFournis(),
      ]);

      console.log("Details:", details);

      if (
        !details ||
        !details.typebenef ||
        (!details.codepresc && !details.codefourn)
      ) {
        throw new Error("Details incomplets");
      }

      const selectedBenef = benefsData.find(
        (benef) => benef.codetype === details.typebenef
      );

      const codespePrescripteur = details.codepresc
        ? details.codepresc.slice(0, 2)
        : null;
      const codespePrestataire = details.codefourn
        ? details.codefourn.slice(0, 2)
        : null;

      const prescripteur = prescripteursData.find(
        (prescripteur) => prescripteur.numFourn === details.codepresc
      );

      const actesData = await specialistesService.AddActe(codespePrestataire);

      console.log("ActesData:", actesData);

      const selectedRowData = {
        ...details,
        datepresc: details.datepresc ? moment(details.datepresc) : undefined,
        datedoc: details.datedoc ? moment(details.datedoc) : undefined,
        montant_remise: details.montant_remise,
        montdoc: details.montdoc,
        libtype: selectedBenef ? selectedBenef.libtype : undefined,
        prescripteurSpe: codespePrescripteur,
        prestataireSpe: codespePrestataire,
        codepresc: prescripteur ? prescripteur.numFourn : undefined,
        natprest: details.natprest,

      };

      setNumdoc(details.numdoc);
      form.setFieldsValue(selectedRowData);

      const actes = details.actes.map((acte, index) => ({
        numero: index + 1,
        libacte: acte.Prestation.libacte,
        qte: acte.qte,
        prix_unitaire: acte.Prestation.tarif,
      }));

      setAddedRows(actes);
      setIsTableVisible(false);

      setAdherents(adherentsData);
      setParticipantsData(participantsData);
      setBeneficiaires(benefData);
      setBenefsData(benefsData);
      setSpecialitesData(specialites);
      setPrescripteursData(prescripteursData);
      setPrestationsData(prestationsData);
      setFournisseurData(fournisseursData);
      setActesData(actesData); // Mettre à jour l'état avec les actes récupérés
      /*   setIsTableVisible(true) */
      setIsTableVisible(actes.length > 0);

      // Mettre à jour directement prestatairesData
      const prestataires = fournisseursData.filter(
        (fournisseur) => fournisseur.codespe === codespePrestataire
      );
      setPrestatairesData(prestataires);

      // Vérifier si le prescripteur a été sélectionné manuellement
      setIsPrescripteurManuallySelected(!!details.codepresc);
    } catch (error) {
      console.error("Erreur lors de la récupération des détails :", error);
      if (error.response) {
        console.error("Erreur de l'API:", error.response.data);
      } else {
        console.error("Erreur de l'application:", error.message);
      }
    } finally {
      setLoadingModal(false); // Masquez l'indicateur de chargement
    }
  };



  const handleModif = () => {
    form
      .validateFields()
      .then(async (values) => {
        const participantDetails = partsData || { categprof: 'N/A' };
        const actes = addedRows.map((row) => ({
          Prestation: {
            codeacte: row.libacte, // Ensure libacte contains the codeacte value
            libacte: row.libacte,
            qte: row.qte,
            coef: 1,
            codespe: values.codespe,
            codeprest: values.codefourn,
          },
          ajustmt: 0,
          codeprest: values.codefourn,
          fexclus: 0,
          freel: 0,
          intitule: "",
          numdoc: "",
          numligne: null,
          qpassur: 0,
          qpmut: 0,
          qte: row.qte,
          tarif: row.prix_unitaire,
          ticket: 0,
        }));
        const docData = {
          actes,
          categprof: participantDetails.categprof,
          natprest: values.natprest,
          codefourn: values.codefourn,
          codesoc: values.codesoc,
          codepresc: values.codepresc,
          datepresc: values.datepresc
            ? values.datepresc.format("YYYY-MM-DD")
            : "",
          datedoc: form.getFieldValue("datedoc")?.format("YYYY-MM-DD") || null,
          codeprest: values.prestataireSpe,
          matribenef: values.matribenef,
          matripart: values.matripart,
          montant_remise: values.montant_remise,
          montdoc: values.montdoc,
          nbarticle: values.nbarticle,
          numdoc: numdoc,
          remb_integral: values.remb_integral,
          typebenef: values.typebenef,
          typedoc: "LGI",
          user_id: userId,
        };

        try {
          await bpiService.UpdateDetailBpi(docData);

          handleCloseModal();
          fetchDataByOption(selectedOption);
          notification.success({
            message: "Succès",
            description: "Le document a été modifié avec succès.",
          });
        } catch (error) {
          console.error("Erreur lors de l'ajout du document :", error);
        }
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      });
  };

  const formatNumberWithSeparator = (number) => {
    return number ? number.toLocaleString() : '0'; // Vérifiez que number est défini avant d'utiliser toLocaleString
  };
  return (
    <div>
      <Card>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "40px" }}
        >
          {/* Partie gauche avec le titre */}
          <Col>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 20px",
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: 10,
                boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
              }}
            >
              <SafetyCertificateOutlined style={{ fontSize: 22, color: "#fff" }} />
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#fff",
                  letterSpacing: 0.5,
                  margin: 0,
                }}
              >
                Lettres de Garantie
              </span>
            </div>
          </Col>

          <Col>
            <Select
              bordered={false}
              style={{
                width: 100,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={handleYearChange}
              value={selectedYear}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>

            <Select
              bordered={false}
              style={{
                width: 200,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={handleSelectChange}
              value={selectedOption}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              <Option value="AA">Tous les Documents</Option>
              <Option value="OK">Traité</Option>
              <Option value="KO">Non Traité</Option>
            </Select>
            <Input
              placeholder="Recherche..."
              bordered={false}
              style={{
                width: 200,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <Button
              className="buttonRecep"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(false)}
              icon={<PlusCircleOutlined />}
            >
              Lettre de prise en charge
            </Button>
            <Button
              className="ButtonbonManuel"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(true)}
              icon={<PlusCircleOutlined />}
            >
              Lettre Facturée
            </Button>
            <Button
              className="buttonExport"
              style={{ marginRight: 10 }}
              onClick={handleExportClick}
              icon={<ExportOutlined />}
            >
              Export
            </Button>
            <Button
              className="buttonRefresh"
              icon={refreshTable ? <Spin /> : <SyncOutlined />}
              onClick={handleRefresh}
            ></Button>
          </Col>
        </Row>
        <TableDOc
          size="small"
          scroll={{
            x: true,
          }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header1-table"
          bordered
          isPharmacieComponent={false}
          loading={loading}
          dataSource={filteredData}
          showSorterTooltip={false}
          showAdditionalColumns={selectedOption === "OK"}
          handleDeleteline={handleDeleteline}
          onEdit={handleEdit}
        />
        <Modal
          open={isModalVisible}
          style={{
            top: 20,
          }}
          footer={null} // Supprime le pied de page par défaut avec OK et Cancel
          onCancel={handleCloseModal}
          maskClosable={false}
          width={900}
          className="modal-header"
          title={
            <div>
              {isEdit
                ? "Modifier Lettre de Garantie"
                : "Création Lettre de Garantie"}
              {isEdit && (
                <div style={{ fontSize: "14px", marginTop: "2px" }}>
                  Numéro : {numdoc}
                </div>
              )}
            </div>
          }
        >
          {loadingModal ? (
            <Spin
              tip="Chargement..."
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          ) : (
            <Form form={form} layout="vertical">

              {isBonManuel && (
                <Row gutter={16}>
                  <Divider orientation="left">
                    Infos Bon
                  </Divider>

                  <>
                    <Col span={8}>
                      <Form.Item
                        name="numdoc"
                        label="Numéro Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez entrer le numéro du bon",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="datedoc"
                        label="Date Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner la date du bon",
                          },
                        ]}
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          disabledDate={(current) =>
                            current && current > moment().endOf("day")
                          }
                          style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="montdoc"
                        label="Montant Bon"
                        initialValue={0}
                      >
                        <InputNumber style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </>

                </Row>
              )}

              <Row gutter={20}>
                <Col span={12}>
                  <Divider orientation="left">
                    Participant
                  </Divider>
                  <Form.Item
                    name="codesoc"
                    label="Société"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une société",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue={"--Selectionner--"}
                      onChange={handleSocieteChange}
                      disabled={isEdit}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {adherents.map((adherent) => (
                        <Option
                          key={adherent.codeadht}
                          value={adherent.codeadht}
                        >
                          {`${adherent.codeadht} - ${adherent.intitule}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="matripart"
                    label="Matricule participant"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      defaultValue={"--Selectionner--"}
                      style={{ width: "100%" }}
                      disabled={!participantsData || isEdit} // Grise si participantsData est null
                      onChange={handleMatPartChange}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {participantsData &&
                        participantsData.map((participant) => (
                          <Option
                            key={participant.numcont}
                            value={participant.numcont}
                          >
                            {`${participant.matricule} - ${isEdit
                              ? participant.prenom + " " + participant.nom
                              : participant.part
                              }`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Divider orientation="left">
                    Prescripteur
                  </Divider>
                  <Form.Item
                    name="prescripteurSpe"
                    label="Spécialités (Prescripteur)"
                  >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue="--Selectionner--"
                      onChange={handlePrescripteurSpecialiteChange}
                      showSearch

                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {specialitesData &&
                        specialitesData.map((specialite) => (
                          <Option
                            key={specialite.codespe}
                            value={specialite.codespe}
                          >
                            {`${specialite.codespe} - ${specialite.intitule}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="codepresc" label="Prescripteur">
                    <Select
                      defaultValue="--Selectionner--"
                      style={{ width: "100%" }}
                      allowClear={false}
                      disabled={!isPrescripteurSelectEnabled && !isEdit}
                      onChange={handlePrescripteurChange}
                      value={
                        form.getFieldValue("codepresc") || "--Selectionner--"
                      }
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {prescripteursData.map((prescripteur) => (
                        <Option
                          key={prescripteur.numFourn}
                          value={prescripteur.numFourn}
                        >
                          {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20}>
                <Col span={12}>
                  <Divider orientation="left">
                    Bénéficiaire
                  </Divider>
                  <Row gutter={16}>
                    <Col span={10}>
                      <Form.Item
                        name="typebenef"
                        label="Types"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner une option",
                          },
                        ]}
                      >
                        <Select
                          style={{ width: "100%", fontSize: "16px" }}
                          disabled={!isMatriculeSelected && !isEdit}
                          defaultValue="--Selectionner--"
                          onChange={handleTypeBenefChange}
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {benefsData &&
                            benefsData.map((benefData) => (
                              <Option
                                key={benefData.codetype}
                                value={benefData.codetype}
                              >
                                {`${benefData.libtype} `}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={14}>
                      {/*  <Form.Item
                        name="matribenef"
                        label="Bénéficiaire"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner une option",
                          },
                        ]}
                      >
                        <Select
                          defaultValue="--Selectionner--"
                          style={{ width: "100%" }}
                          disabled={!isBeneficiaireSelected && !isEdit}
                          showSearch
                        >
                          {beneficiaires.map((beneficiaire) => (
                            <Option
                              key={beneficiaire.matribenef}
                              value={beneficiaire.matribenef}
                            >
                              {`${beneficiaire.matribenef} - ${
                                beneficiaire.prenoms
                                  ? beneficiaire.prenoms + " "
                                  : ""
                              }${beneficiaire.nom ? beneficiaire.nom : ""}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item> */}
                      <Form.Item
                        name="matribenef"
                        label="Bénéficiaire"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner une option",
                          },
                        ]}
                      >
                        <Select
                          defaultValue="--Selectionner--"
                          style={{ width: "100%" }}
                          disabled={!isBeneficiaireSelected && !isEdit}
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {Array.isArray(beneficiaires) &&
                            beneficiaires.map((beneficiaire) => (
                              <Option
                                key={beneficiaire.matribenef}
                                value={beneficiaire.matribenef}
                              >
                                {`${beneficiaire.matribenef} - ${beneficiaire.prenoms ? beneficiaire.prenoms + " " : ""
                                  }${beneficiaire.nom ? beneficiaire.nom : ""}`}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>

                    </Col>
                  </Row>
                  <Divider orientation="left">
                    Prestataire
                  </Divider>
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        name="prestataireSpe"
                        label="Spécialités (Prestataire)"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner une spécilité",
                          },
                        ]}
                      >
                        <Select
                          style={{ width: "100%" }}
                          defaultValue="--Selectionner--"
                          onChange={handlePrestataireSpecialiteChange}
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {specialitesData &&
                            specialitesData.map((specialite) => (
                              <Option
                                key={specialite.codespe}
                                value={specialite.codespe}
                              >
                                {`${specialite.codespe} - ${specialite.intitule}`}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                      <Form.Item name="codefourn" label="Prestataire"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner un prestataire",
                          },
                        ]}>
                        <Select
                          defaultValue="--Selectionner--"
                          style={{ width: "100%" }}
                          disabled={!isPrescripteurSelectEnabled && !isEdit}
                          onChange={handlePrestataireChange}
                          value={
                            form.getFieldValue("codefourn") ||
                            "--Selectionner--"
                          }
                          showSearch
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {prestatairesData.map((prescripteur) => (
                            <Option
                              key={prescripteur.numFourn}
                              value={prescripteur.numFourn}
                            >
                              {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    name="natprest"
                    label="Nature prestation"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select style={{ width: "100%" }}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {prestationsData &&
                        prestationsData.map((prestation) => (
                          <Option
                            key={prestation.codeprest}
                            value={prestation.codeprest}
                          >
                            {`${prestation.codeprest} - ${prestation.intitule}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Divider orientation="left">
                    Actes
                  </Divider>
                  <Row gutter={16}>
                    <Form.Item
                      initialValue={0}
                      name="nbarticle"
                      label=" Nombre d'article"
                    >
                      <InputNumber
                        disabled={!isPrescripteurSelectEnabled && !isEdit}
                      />
                    </Form.Item>

                    <Form.Item
                      name="datepresc"
                      label="Date d'ordonnance"
                      style={{ marginRight: "16px" }}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        disabled={!isPrescripteurSelectEnabled && !isEdit}
                        disabledDate={(current) =>
                          current && current > moment().endOf("day")
                        }
                        onChange={handleDateChange}
                      />
                    </Form.Item>
                    <Form.Item initialValue={0} label="Quantité Total">
                      <InputNumber
                        value={qteTotal}
                        disabled={!isPrescripteurSelectEnabled && !isEdit}
                      />
                    </Form.Item>
                    <Form.Item
                      name="montant_remise"
                      label="Remise"
                      initialValue={0}
                      className={isSaisirMedicamentClicked ? "" : "hidden"}
                    //  rules={[{ required: true, message: 'Veuillez saisir la quantité' }]}
                    >
                      <InputNumber />
                    </Form.Item>
                  </Row>
                  <Form.Item
                    name="libacte"
                  // rules={[{ required: true, message: 'Veuillez sélectionner une option' }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue="Saisir les actes"
                      disabled={
                        (!isPrescripteurSelectEnabled || !isDateSelected) &&
                        !isEdit
                      }
                      onChange={handleActesChange}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {actesData &&
                        actesData.map((acte) => (
                          <Option key={acte.codeacte} value={acte.codeacte}>
                            {`${acte.libacte} `}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>

                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        name="qte"
                        label="Qté"
                        initialValue={1}
                        className={isSaisirMedicamentClicked ? "" : "hidden"}
                      //  rules={[{ required: true, message: 'Veuillez saisir la quantité' }]}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name="prix_unitaire"
                        label="P.U"
                        className={isSaisirMedicamentClicked ? "" : "hidden"}
                        initialValue={0}
                      //    rules={[{ required: true, message: 'Veuillez saisir le prix unitaire' }]}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>

                    <Col span={6}>
                      <PlusCircleOutlined
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          color: "#4DBD74",
                        }}
                        className={isSaisirMedicamentClicked ? "" : "hidden"}
                        onClick={handleAddRow}
                      />
                      <CloseCircleFilled
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          paddingLeft: "8px",
                          color: "#ff2317",
                        }}
                        className={isSaisirMedicamentClicked ? "" : "hidden"}
                        onClick={handleClearTable}
                      />
                    </Col>
                  </Row>

                  {isTableVisible && (
                    <Table
                      style={{
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                      showSorterTooltip={false}
                      className="custom-header1-table"
                      bordered
                      dataSource={[...addedRows]}
                      scroll={{ x: true }}
                      columns={[
                        {
                          title: "N°",
                          dataIndex: "numero",
                          key: "numero",
                          align: "center",
                        },
                        {
                          title: "Nom",
                          dataIndex: "libacte",
                          key: "libacte",
                        },
                        {
                          title: "Qt",
                          dataIndex: "qte",
                          key: "qte",
                          align: "center",
                        },
                        {
                          title: "P.U",
                          dataIndex: "prix_unitaire",
                          key: "prix_unitaire",
                          align: "right",
                          render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
                        },
                        {
                          title: "Montant",
                          dataIndex: "montant",
                          key: "montant",
                          align: "right",
                          render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
                        },
                        {
                          title: (
                            <div
                              style={{
                                backgroundColor: "#010f1c",
                                color: "white",
                                padding: "1px",
                              }}
                            ></div>
                          ),
                          dataIndex: "actions",
                          key: "actions",
                          align: "center",
                          fixed: "right", // Fixe la colonne à droite
                          render: (text, record) => (
                            <span>
                              <Popconfirm
                                title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
                                onConfirm={() => handleDelete(record)}
                                okText="Oui"
                                cancelText="Non"
                              >
                                <Tooltip title="Supprimer">
                                  <DeleteFilled
                                    style={{ cursor: "pointer", color: "red" }}
                                  />
                                </Tooltip>
                              </Popconfirm>
                            </span>
                          ),
                        },
                      ]}
                      summary={(pageData) => {
                        let totalMontant = 0;
                        pageData.forEach((item) => {
                          totalMontant += item.montant;
                        });
                        return (
                          <Table.Summary.Row align="right" justify>
                            <Table.Summary.Cell index={0}>
                              <strong>Total</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} />
                            <Table.Summary.Cell index={2} />
                            <Table.Summary.Cell index={3} />
                            <Table.Summary.Cell index={4}>
                              <Text>
                                <strong>{formatNumberWithSeparator(totalMontant)}</strong>
                              </Text>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        );
                      }}
                    />
                  )}
                </Col>
              </Row>
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Form.Item name="remb_integral" style={{ marginBottom: 0 }} valuePropName="checked">



                  <Checkbox>  Remboursement Intégral</Checkbox>

                </Form.Item>
                <Button
                  type="dashed"
                  danger
                  onClick={handleCloseModal}
                  style={{ marginRight: 8 }}
                >
                  Fermer
                </Button>
                {isEdit ? (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleModif}
                  >
                    Modifier
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleOk}
                  >
                    Valider
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Modal>
        <Modal
          open={isExportModalVisible}
          onCancel={handleExportModalCancel}
          onOk={handleExportModalOk}
          title="Sélectionner les colonnes à exporter"
        >
          <Checkbox.Group
            style={{ width: "100%" }}
            value={selectedColumns}
            onChange={handleColumnChange}
          >
            <Row>
              {Object.keys(filteredData[0] || {}).map((col) => (
                <Col span={8} key={col}>
                  <Checkbox value={col}>{col}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Modal>
        <Modal
          visible={isParticipantInactive}
          title="Participant inactif!"
          onCancel={() => {
            setIsParticipantInactive(false);
            setSelectedParticipant(null);
          }}
          footer={
            userProfil === 'role_1' || userProfil === 'role_2' ? (
              [
                <Button key="cancel" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Annuler
                </Button>,
                <Button key="confirm" type="primary" onClick={() => {
                  setIsMatriculeSelected(true);
                  const benefData = participantsIpmService.getBenefParticipant(selectedParticipant.numcont);
                  setAllBeneficiaires(benefData);
                  setBeneficiaires(benefData);
                  setPartsData(selectedParticipant);
                  setIsBeneficiaireSelected(false);
                  form.setFieldsValue({
                    codetype: undefined,
                    matribenef: undefined,
                  });
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                }}>
                  Valider
                </Button>
              ]
            ) : (
              [
                <Button key="ok" type="primary" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Ok
                </Button>
              ]
            )
          }
        >
          <p>Participant inactif! Veuillez confirmer cette opération.</p>
        </Modal>

      </Card>
    </div>
  );
};

export default Lettregarant;
